export default __webpack_public_path__ + "static/media/Page12.7a4befcf.txt";